export enum SHAREHOLDER_INVESTMENT_STATUS {
	NEW_OFFER = 'NEW_OFFER',
	NEEDS_ATTENTION = 'NEEDS_ATTENTION',
	PENDING_APPROVAL = 'PENDING_APPROVAL',
	COMPLETED = 'COMPLETED',
	PENDING = 'PENDING',
}
